var App = App || {};

App.SiteHeader = (function ($) {
    "use strict";

    var selectorItems = $(".site-header-primary > nav > ul").children("li"),
        selectorLinks = selectorItems.children("a, button");

    function init() {
        applySeparators(selectorItems);

        $(".site-header-primary").find("mega-menu").each(function () {
            $(this).find("a").attr("tabindex", -2);
        });;

        /**********************************************************************************
         LEVEL ONE ITEM ARROWS
        /*********************************************************************************/
        selectorLinks.keydown(function (e) {
            // right arrow
            if (e.keyCode === 39) {
                e.preventDefault();
                $(this).parent("li").next("li").children("a, button").focus();
            }
            // left arrow
            else if (e.keyCode === 37) {
                e.preventDefault();
                $(this).parent("li").prev("li").children("a, button").focus();
            }
        });

        /**********************************************************************************
         Lvl one item separators
        /*********************************************************************************/
        $(window).resize(function () {
            applySeparators(selectorItems);
        })

        /**********************************************************************************
         OLB offcanvas link separators
        /*********************************************************************************/
        $(".offcanvas-online-banking").on('show.bs.offcanvas', function () {
            var olbLinks = $(".offcanvas-online-banking .ribbon-login-help-overlay a");
            if (olbLinks.length) {
                var currentLineTop = 0,
                    currentItemTop;
                olbLinks.each(function () {
                    currentItemTop = $(this).offset().top;
                    if (currentItemTop == currentLineTop) {
                        $(this).addClass("separated"); //add separator only if this is not the first item on the line
                    } else {
                        currentLineTop = currentItemTop;
                    }
                });
            }
        })

        $(".offcanvas-online-banking").on('hidden.bs.offcanvas', function () {
            $(".offcanvas-online-banking .ribbon-login-help-overlay a").removeClass("separated");
        })
    }

    function applySeparators(lvl1Items) {
        lvl1Items.removeClass("separated");
        if (lvl1Items.length) {
            var currentLineTop = 0,
                currentItemTop;
            lvl1Items.each(function () {
                currentItemTop = $(this).offset().top;
                if (currentItemTop == currentLineTop) {
                    $(this).addClass("separated"); //add separator only if this is not the first item on the line
                } else {
                    currentLineTop = currentItemTop;
                }
            });
        }
    }

    return {
        init: init
    };

})(jQuery);

$(function () {
    App.SiteHeader.init();
});